
<div mat-dialog-title>Accounts cannot be assigned<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
  <mat-dialog-content>
    <mat-card class="warn block">
      <mat-card-title class="warn">Your .csv file includes invalid records</mat-card-title>
      <mat-card-subtitle  style="font-family: Arial;font-size: 13px;color: #000000;">The records listed below will not get imported</mat-card-subtitle>
    </mat-card>
    <div>
      <irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "'240px'"
        [showSideBar] = "false"
        [gridOptions] = "gridOptions"
        [rowData] = 'data.invalidRecords'
        (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel entire import</button>
    <button id="continueButton" (click)="completeImport()" [disabled]="!(data.validRecords && data.validRecords.length > 0)" class="btn-medium-primary">Finish</button>
  </mat-dialog-actions>
